import React from "react";

const ScreenOff = () => {
  return (
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="white-on-shout"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.35646 6.51465L8.17724 8.17698C8.42845 8.06329 8.70733 8 9.00099 8H25.001C26.1056 8 27.001 8.89543 27.001 10V20C27.001 21.1046 26.1056 22 25.001 22H23.3179L28.5366 26.7646L27.2661 28.1562L5.08594 7.90628L6.35646 6.51465ZM7.00099 12.1387V20C7.00099 21.1046 7.89642 22 9.00099 22H17.8022L13.3408 17.9268C11.7291 18.7083 10.4246 19.539 10.001 20C10.001 18.5233 10.7066 17.3752 11.7523 16.4766L7.00099 12.1387ZM19.5903 23.6324C18.6861 23.5106 17.8449 23.4483 17.0011 23.4483C14.4914 23.4482 12.0054 23.9993 7.81514 25.0288L8.29231 26.9711C12.5231 25.9316 14.7739 25.4482 17.0011 25.4483C18.5604 25.4483 20.1313 25.6852 22.3852 26.1841L19.5903 23.6324ZM15.1893 14.5788L17.2212 16.4339C18.2563 16.153 19.2491 15.9984 20.081 16.0569V18.619L25.001 14.3095L20.081 10V13.2321C19.8605 13.2913 19.5652 13.3591 19.2143 13.4396L19.2142 13.4396L19.2142 13.4396C18.1873 13.6753 16.6845 14.0202 15.1893 14.5788Z"
        fill="#A6A6A6"
      />
    </svg>
  );
};

export default ScreenOff;
